import { TableCellProps } from '@material-ui/core'
import React from 'react'
import Heading, { HeadingLevel } from '../Heading'
import { TableColumn, TableRow } from './Table'

/**
 * Create a header row.
 *
 * @param align - Alignment prop for column.
 * @param headings - List of heading strings.
 */
export const createHeaderRow = (align: TableCellProps['align'], ...headings: string[]): TableRow => ({
    columns: headings.map(
        (heading: string): TableColumn => ({
            content: (
                <Heading className='table-heading' level={HeadingLevel.FOUR}>
                    {heading}
                </Heading>
            ),
            props: { align }
        })
    )
})
